import { render, staticRenderFns } from "./SignedModel.vue?vue&type=template&id=495afa5d&scoped=true&"
import script from "./SignedModel.vue?vue&type=script&lang=js&"
export * from "./SignedModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495afa5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495afa5d')) {
      api.createRecord('495afa5d', component.options)
    } else {
      api.reload('495afa5d', component.options)
    }
    module.hot.accept("./SignedModel.vue?vue&type=template&id=495afa5d&scoped=true&", function () {
      api.rerender('495afa5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eletronicSigned/modules/SignedModel.vue"
export default component.exports